export default defineNuxtPlugin(async (nuxtApp) => {
	const getEnvironments = async () => {
		try {
			// @ts-ignore
			return (await import("@/environments.js")).default;
		} catch (error) {
			return {};
		}
	};
	const environments = await getEnvironments();
	const runtimeConfig = useRuntimeConfig();
	if (runtimeConfig.public.env === "development") {
		const cookie = useCookie("DEV--environment");
		const envMap = new Map(Object.entries(environments));
		const cookieEnv = envMap.get(cookie.value || "Prod");

		if (runtimeConfig.public.env === "development" && cookie.value && cookieEnv) {
			for (const [domain, value] of Object.entries(cookieEnv)) {
				// biome-ignore lint/suspicious/noPrototypeBuiltins: Checks if object has property
				if (runtimeConfig.public.hasOwnProperty(domain)) {
					runtimeConfig.public[domain] = value;
				}
			}
		}
	}
});
